import GetJsonData from './dataAccess';
import { dropDown } from './interfaces';

export const getDatabaseTables = async (): Promise<dropDown[]> => {
  try {
    const data = await GetJsonData('Database/Tables');
    return data;
  } catch (error) {
    console.error('Error fetching database tables:', error);
    throw error;
  }
};

export const getTableData = async (tableName: string): Promise<any[]> => {
  try {
    const data = await GetJsonData(`Database/TableData/${encodeURIComponent(tableName)}`);
    return data;
  } catch (error) {
    console.error('Error fetching table data:', error);
    throw error;
  }
};
